import { createContext } from 'react';

const TransactionContext = createContext();

export default TransactionContext;
